import React, { useState } from "react";
import { Table, Dropdown, Button, Modal, Form } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import { addNsns, deleteNsn, updateNsn } from "../../api/api";

const NsnInfo = ({ nsnInfo, onEdit, onDelete, itemId, onNsnAdded }) => {
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({ nsn: "", size: "", comment: "" });
    const [saving, setSaving] = useState(false);
    const [deleteError] = useState(null);
    const [editingIdx, setEditingIdx] = useState(null);
    const [editForm, setEditForm] = useState({ nsn: "", size: "", comment: "" });
    const [editSaving, setEditSaving] = useState(false);
    const [editError, setEditError] = useState(null);

    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setForm({ nsn: "", size: "", comment: "" });
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await addNsns([
                {
                    nsn: form.nsn,
                    size: form.size,
                    comment: form.comment,
                    item_id: itemId
                }
            ]);
            handleClose();
            if (onNsnAdded) onNsnAdded();
            toast.success("NSN added!");
        } catch (err) {
            toast.error("Failed to add NSN");
        }
        setSaving(false);
    };

    const handleDelete = async (nsn) => {
        try {
            await deleteNsn(nsn.id);
            if (onNsnAdded) onNsnAdded();
            toast.success("NSN deleted!");
        } catch (err) {
            toast.error("Failed to delete NSN");
        }
    };

    const handleEditClick = (nsn, idx) => {
        setEditingIdx(idx);
        setEditForm({ nsn: nsn.nsn, size: nsn.size, comment: nsn.comment, id: nsn.id });
        setEditError(null);
    };

    const handleEditChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleEditCancel = () => {
        setEditingIdx(null);
        setEditForm({ nsn: "", size: "", comment: "" });
        setEditError(null);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditSaving(true);
        try {
            await updateNsn(editForm.id, {
                nsn: editForm.nsn,
                size: editForm.size,
                comment: editForm.comment
            });
            setEditingIdx(null);
            setEditForm({ nsn: "", size: "", comment: "" });
            if (onNsnAdded) onNsnAdded();
            toast.success("NSN updated!");
        } catch (err) {
            toast.error("Failed to update NSN");
        }
        setEditSaving(false);
    };

    return (
        <div style={{ marginTop: 16 }}>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                    position: "bottom-center"
                }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5>NSN Sizes</h5>
                <Button size="sm" onClick={handleShow}>Add NSN</Button>
            </div>
            {nsnInfo && nsnInfo.length > 0 ? (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>NSN</th>
                            <th>Size</th>
                            <th>Comment</th>
                            <th style={{ width: 1 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {nsnInfo.map((nsn, idx) => (
                            editingIdx === idx ? (
                                <tr key={idx}>
                                    <td>
                                        <Form.Control
                                            name="nsn"
                                            value={editForm.nsn}
                                            onChange={handleEditChange}
                                            size="sm"
                                            required
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleEditSubmit(e);
                                                } else if (e.key === "Escape") {
                                                    e.preventDefault();
                                                    handleEditCancel();
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            name="size"
                                            value={editForm.size}
                                            onChange={handleEditChange}
                                            size="sm"
                                            required
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleEditSubmit(e);
                                                } else if (e.key === "Escape") {
                                                    e.preventDefault();
                                                    handleEditCancel();
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            name="comment"
                                            value={editForm.comment}
                                            onChange={handleEditChange}
                                            size="sm"
                                            required
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleEditSubmit(e);
                                                } else if (e.key === "Escape") {
                                                    e.preventDefault();
                                                    handleEditCancel();
                                                }
                                            }}
                                        />
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        <div style={{ display: "flex", gap: 4, justifyContent: "flex-end" }}>
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={handleEditSubmit}
                                                disabled={editSaving}
                                                style={{
                                                    padding: "0 8px",
                                                    minWidth: 28,
                                                    minHeight: 28,
                                                    fontSize: 16,
                                                    lineHeight: 1
                                                }}
                                                title="Save"
                                            >
                                                ✔
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="secondary"
                                                onClick={handleEditCancel}
                                                disabled={editSaving}
                                                style={{
                                                    padding: "0 8px",
                                                    minWidth: 28,
                                                    minHeight: 28,
                                                    fontSize: 16,
                                                    lineHeight: 1
                                                }}
                                                title="Cancel"
                                            >
                                                ✖
                                            </Button>
                                        </div>
                                        {editError && (
                                            <div style={{ color: "red", fontSize: 12 }}>{editError}</div>
                                        )}
                                    </td>
                                </tr>
                            ) : (
                                <tr key={idx}>
                                    <td>{nsn.nsn}</td>
                                    <td>{nsn.size}</td>
                                    <td>{nsn.comment}</td>
                                    <td style={{ textAlign: "right" }}>
                                        <Dropdown align="end">
                                            <Dropdown.Toggle
                                                variant="secondary"
                                                size="sm"
                                                style={{ padding: "0 8px" }}
                                                id={`dropdown-nsn-${idx}`}
                                            >
                                                &#x22EE;
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => handleEditClick(nsn, idx)}>Edit</Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => handleDelete(nsn)}
                                                >
                                                    Delete
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            )
                        ))}
                    </tbody>
                </Table>
            ) : (
                <div style={{ padding: "16px", textAlign: "center", color: "#888" }}>
                    No NSN sizes found. Click "Add NSN" to create one.
                </div>
            )}
            {deleteError && (
                <div style={{ color: "red", marginTop: 8 }}>{deleteError}</div>
            )}
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add NSN</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>NSN</Form.Label>
                            <Form.Control name="nsn" value={form.nsn} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Size</Form.Label>
                            <Form.Control name="size" value={form.size} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Comment</Form.Label>
                            <Form.Control name="comment" value={form.comment} onChange={handleChange} />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                        <Button type="submit" variant="primary" disabled={saving}>
                            {saving ? "Saving..." : "Add"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

export default NsnInfo;
